/// <reference types="vite-plugin-svgr/client" />
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ILesson } from '../../@types'
import { THEME } from '../../global'

interface IProps {
  lessonState?: 'Active' | 'Done' | 'Lock'
  listMode: boolean
  data: ILesson
  index: number
}

interface ILessonProps {
  lessonState?: 'Active' | 'Done' | 'Lock'
  listMode: boolean
  index: number
  data: ILesson
}

export function Lesson({
  listMode,
  data,
  index,
  lessonState = 'Lock',
}: ILessonProps) {
  if (!listMode)
    return (
      <GridMode
        data={data}
        index={index}
        listMode={listMode}
        lessonState={lessonState}
      />
    )

  return (
    <ListMode
      data={data}
      index={index}
      listMode={listMode}
      lessonState={lessonState}
    />
  )
}

function GridMode({ listMode, data, index, lessonState }: IProps) {
  // const selectFirstDigitRegex = /^\d+/
  const navigate = useNavigate()
  const st = lessonState === 'Active'
  const borderColor = st ? THEME.colors.primary : THEME.colors.tertiary
  const textColor = lessonState !== 'Lock' ? '#fff' : THEME.colors.disabled

  return (
    <Grid item xs={2} sm={4} md={4} style={{ maxWidth: 200 }}>
      <a
        onClick={() => {
          lessonState !== 'Lock' && navigate('/user/player')
        }}
      >
        <div
          style={{ borderColor }}
          className="h-[220px] border rounded-[12px] bg-[url(https://fluencycorp.com/wp-content/uploads/2019/01/hardest-part-learning-english.jpg)] bg-center bg-cover"
        >
          <div className="relative bg-black p-2 w-[100%] h-[100%] rounded-[12px] bg-opacity-35">
            <ModuleStatusIcon
              data={data}
              index={index}
              listMode={listMode}
              lessonState={lessonState}
            />

            <div className="absolute left-3 right-3 bottom-3">
              <h2
                className="w-[85%] text-xl mb-1 font-bold"
                style={{ color: textColor }}
              >
                {data.title}
              </h2>
              <div
                style={{ color: textColor }}
                className="flex flex-1 justify-between"
              >
                <p className="bg-red text-sm ">Modulo {data.module.number}</p>
                {/* <p className="bg-red text-sm">
                  {data.duration.match(selectFirstDigitRegex)} min
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </a>
    </Grid>
  )
}

function ListMode({ listMode, data, index, lessonState }: IProps) {
  const navigate = useNavigate()
  const st = lessonState === 'Active'
  const borderColor = st ? THEME.colors.primary : THEME.colors.tertiary
  const indexColor =
    lessonState === 'Active'
      ? THEME.colors.primary
      : lessonState === 'Lock'
        ? THEME.colors.tertiary
        : THEME.colors.success
  const textColor = lessonState !== 'Lock' ? '#fff' : THEME.colors.disabled

  return (
    <a
      onClick={() => {
        lessonState !== 'Lock' && navigate(`/user/player/${data.id}`)
      }}
    >
      <div
        style={{ borderColor }}
        className="flex mb-2 p-2  border justify-between rounded-md items-center"
      >
        <div className="flex w-full rounded-md items-center">
          <div
            style={{ backgroundColor: indexColor }}
            className="flex text-b items-center mr-2 justify-center rounded-full bg-primary h-8 w-8"
          >
            <p className="text-secondary text-sm font-bold">{index + 1}</p>
          </div>

          <h2
            className="w-[85%] text-xl font-bold"
            style={{ color: textColor }}
          >
            {data.title}
          </h2>
        </div>

        <ModuleStatusIcon
          data={data}
          index={index}
          listMode={listMode}
          lessonState={lessonState}
        />
      </div>
    </a>
  )
}

function ModuleStatusIcon({ lessonState, listMode }: IProps) {
  const st = lessonState !== 'Lock'
  const moduleStatusColor = st ? THEME.colors.success : THEME.colors.disabled
  const elementStyle = listMode ? '' : 'absolute top-0 left-3'

  return (
    <div className={elementStyle}>
      {lessonState === 'Done' ? (
        <CheckCircleIcon
          sx={{
            color: moduleStatusColor,
          }}
        />
      ) : lessonState === 'Lock' ? (
        <LockOutlinedIcon
          sx={{
            color: THEME.colors.disabled,
          }}
        />
      ) : (
        listMode && <ArrowForwardIosIcon />
      )}
    </div>
  )
}
